module.exports = __webpack_public_path__ + "media/images/talent/lp/mv01-c365d9fe699472912ec1adefe1ec2dc5.png";